export const onlineOrigin = (() => {
  console.log(`当前环境：${window.location.origin}`);
  if (window.location.origin.includes("localhost")) {
    return "https://xt12366.cn/";
  }
  return window.location.origin;
})();
export const privateAuthUserList = [
  "15153866288",
  "13562807355",
  "aabb3002",
  "18264822355",
  "17865810525",
];
// "/landing",
// "/user-protocol",
// "/login",
// "/register",
// "/reset-password",
// "/share-chat",
// "/table-result",
// "/404",

const noPermissionVisit = [
  { path: "/landing", mobileOK: false },
  { path: "/user-protocol", mobileOK: false },
  { path: "/login", mobileOK: false },
  { path: "/register", mobileOK: false },
  { path: "/reset-password", mobileOK: false },
  { path: "/share-chat", mobileOK: true },
  { path: "/weapp", mobileOK: true },
  { path: "/table-result", mobileOK: true },
  { path: "/404", mobileOK: false },
];

export const isNoPermissionVisit = (path) => {
  return noPermissionVisit.some((item) => path.startsWith(item.path));
};
export const linkToWeapp = (path) => {
  const isMoble =
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) !== null;

  if (!isMoble) {
    return false;
  }
  const item = noPermissionVisit.find((item) => path.startsWith(item.path));
  return item && item.mobileOK ? false : true;
};

